
export const SERVER_VALIDATION_ERRORS = "SERVER_VALIDATION_ERRORS"